import { Segment } from '@/components/inventory-toolbar';
import { useInventoryId } from '@/hooks/use-inventory-id';
import { usePathwayScenarioId } from '@/hooks/use-scenario-id';
import { useGetPathwayScenarioQuery } from '@/api/pathway-scenarios';
import { pathwayScenarioPath } from '@/links';

const ToolbarPathwayScenario = () => {
  const inventoryId = useInventoryId();
  const scenarioId = usePathwayScenarioId();
  const { data: scenario, isSuccess } = useGetPathwayScenarioQuery(scenarioId);

  return isSuccess ? (
    <Segment
      to={pathwayScenarioPath(inventoryId, scenarioId)}
      label={scenario.name}
    />
  ) : null;
};

export { ToolbarPathwayScenario };
